var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignCaution = function SvgSignCaution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 3h20v10h-4v8h-2v-8H8v8H6v-8H2zm16.97 8L20 9.97V7.15L16.15 11zm-5.65 0 6-6H16.5l-6 6zm-5.66 0 6-6h-2.83l-6 6zM5.18 5 4 6.18V9l4-4z"
  })));
};
export { SvgSignCaution as ReactComponent };
export default "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M2 3H22V13H18V21H16V13H8V21H6V13H2V3ZM18.97 11L20 9.97V7.15L16.15 11H18.97ZM13.32 11L19.32 5H16.5L10.5 11H13.32V11ZM7.66 11L13.66 5H10.83L4.83 11H7.66ZM5.18 5L4 6.18V9L8 5H5.18Z' fill='%234A6067'/%3e %3c/svg%3e";